import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { PasswordStrengthFlags } from '../validators/password-strength.validator';

@Component({
  selector: 'app-password-strength-checklist',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './password-strength-checklist.component.html',
  styleUrls: ['./password-strength-checklist.component.scss']
})
export class PasswordStrengthChecklistComponent {
  @Input() flags: PasswordStrengthFlags = {
    minLength: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false
  };
}
